module.exports = __webpack_public_path__ + "assets/img/menu_bg_6.057316fa.png";